// Turkish message translations
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "Bu yanıt uzunluk sınırına ulaştığı için kısaltıldı ve eksik olabilir.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "Bu istek güvenlik kuralları nedeniyle yanıtlanamıyor. Lütfen yeniden ifade edin veya farklı bir konu sorun.",
  // Common UI elements
  "Send": "Gönder",
  "Clear chat": "Sohbeti temizle",
  "Support": "Destek",
  "Settings": "Ayarlar",
  "Language": "Dil",
  "Theme": "Tema",
  "Font Size": "Yazı Boyutu",
  "Select language": "Dil seçin",
  
  // Chat interface
  "Type your message...": "Mesajınızı yazın...",
  "Thinking...": "Düşünüyor...",
  "Ministry of Commerce Laws Expert": "MoC Kanunları Uzmanı",
  "by MJ": "MJ tarafından",
  "Mila": "Mila",
  
  // Frameworks
  "Automatic detection": "Otomatik algılama",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. TB Şirketler Kanunu",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. TB Profesyonel Şirketler Kanunu",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. TB Ticaret Sicili Kanunu",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. Ticaret Bakanlığı Kanunu",
  "MOC_TRADE_NAMES_LAW": "A5. TB Ticari İsimler Kanunu",
  "MOC_GCC_TRADEMARK_LAW": "A6. KİK Ticari Marka Kanunu",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. TB Ticari Senetler Kanunu",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. TB Ticari Rehin Kanunu",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. TB Menkul Mal Teminatı Kanunu",
  "MOC_INSOLVENCY_LAW": "B4. TB İflas Kanunu",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. TB Ticari Acenteler Kanunu",
  "MOC_FRANCHISE_LAW": "C2. TB Franchise Kanunu",
  "MOC_ECOMMERCE_LAW": "C3. TB E-ticaret Kanunu",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. TB Ticaret Odaları Kanunu",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. TB Ticari Defterler Kanunu",
  "MOC_COMMERCIAL_DATA_LAW": "D2. TB Ticari Veri Kanunu",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. TB Kamu Depolama Kanunu",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. TB Standartlar ve Metroloji Kanunu",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. TB Kalibrasyon ve Ölçüm Kanunu",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. TB Özel Laboratuvarlar Kanunu",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. TB Değerli Metaller ve Değerli Taşlar Kanunu",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. TB Kimyasal İthalat Yönetimi Kanunu",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. TB Muhasebe ve Denetim Kanunu",
  "MOC_VALUERS_LAW": "F2. TB Değerleme Uzmanları Kanunu",
  "MOC_ENGINEERS_LAW": "F3. TB Mühendisler Kanunu",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. TB Gizleme Karşıtı Kanun",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. TB Kara Para Aklamayla Mücadele Kanunu",
  "MOC_ARBITRATION_LAW": "G3. TB Tahkim Kanunu",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. TB Ticari Tahrifatla Mücadele Kanunu",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. KİK Dampingle Mücadele Kanunu",
  
  // Models
  "Claude by Anthropic": "Anthropic'in Claude'u",
  "DeepSeek by Groq": "Groq'un DeepSeek'i",
  "MJ Lab Mode": "MJ Lab Modu",
  
  // Messages
  "Language changed to {{locale}}": "Dil {{locale}} olarak değiştirildi",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Merhaba, ben {{name}}, MJ tarafından yapılmış bir yapay zeka asistanıyım.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "Suudi Arabistan'ın Ticaret Bakanlığı kanunları ve düzenlemeleri konusunda uzmanım.",
  "Ask me a question, and I will gladly answer you.": "Bana bir soru sorun, memnuniyetle cevap vereceğim.",
  "Do not share confidential data.": "Gizli verileri paylaşmayın.",
  "I am powered using": "Çalışma kaynağım",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Feragatname:** {{name}}, varsayımlardan veya yanlışlıklardan kaçınarak Suudi Arabistan Ticaret Bakanlığı kanunları ve düzenlemelerinden veri kullanarak yanıt vermek üzere tasarlanmış deneysel bir yapay zeka asistanıdır. Davranışlarından veya yanıtlarının doğruluğundan sorumlu değilim.",
  
  // Error messages
  "An error occurred": "Bir hata oluştu",
  "Failed to change language": "Dil değiştirilemedi",
  "Please try again": "Lütfen tekrar deneyin",
  "Connection lost": "Bağlantı kesildi",
  "Reconnecting...": "Yeniden bağlanıyor...",
  "Nothing to clear": "Temizlenecek bir şey yok",
  "All messages cleared": "Tüm mesajlar temizlendi",
  "All data cleared": "Tüm veriler temizlendi",
  "Storage limit reached": "Depolama sınırına ulaşıldı",
  "Some older messages were removed to save space.": "Alan kazanmak için bazı eski mesajlar kaldırıldı.",
  "Error": "Hata",
  
  // Tooltips
  "Increase font size": "Yazı boyutunu artır",
  "Decrease font size": "Yazı boyutunu azalt",
  "Reset font size": "Yazı boyutunu sıfırla",
  "Change theme": "Temayı değiştir",
  "Support the project": "Projeyi destekle",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} karakter kaldı",
  "{{remainingChars}} characters left": "{{remainingChars}} karakter kaldı",
  
  // Message actions
  "Message copied to clipboard": "Mesaj panoya kopyalandı",
  "Read": "Oku",
  "Summarize": "Özetle",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Mesaj Önerileri",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "Suudi Arabistan Ticaret Bakanlığı kanunları hakkında hızlı bir şekilde konuşma başlatmak için bir soru seçin.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "Suudi Arabistan'da limited şirket kurmak için Şirketler Kanunu kapsamındaki ana gereksinimler nelerdir?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "Ticari Acenteler Kanunu, yabancı şirketler ile Suudi acenteler arasındaki ilişkileri nasıl düzenlemektedir?",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "Suudi Arabistan E-ticaret Kanunu, çevrimiçi tüketiciler ve işletmeler için hangi koruyucu düzenlemeleri sağlamaktadır?",
  
  // Audio Player Dialog
  "AI Summary": "Yapay Zeka Özeti",
  "Listen to the summarized response using our AI Service.": "Yapay Zeka Servisimizi kullanarak özetlenmiş yanıtı dinleyin.",
  "Generating summary...": "Özet oluşturuluyor...",
  "Preparing audio...": "Ses hazırlanıyor...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Metin işlenemedi. Lütfen tekrar deneyin.",
  "Failed to auto-play audio. Click play to try again.": "Ses otomatik oynatılamadı. Tekrar denemek için oynat'a tıklayın.",
  "Failed to load audio. Please try again.": "Ses yüklenemedi. Lütfen tekrar deneyin.",
  "Audio playback was aborted.": "Ses oynatma iptal edildi.",
  "Network error occurred while loading audio.": "Ses yüklenirken ağ hatası oluştu.",
  "Audio decoding failed.": "Ses kodu çözülemedi.",
  "Audio format not supported.": "Ses formatı desteklenmiyor.",
  "Failed to setup audio playback": "Ses oynatma ayarlanamadı",
  "Failed to generate speech": "Konuşma oluşturulamadı",
  "Failed to generate audio. Please try again.": "Ses oluşturulamadı. Lütfen tekrar deneyin.",
  "Failed to play audio. Please try again.": "Ses oynatılamadı. Lütfen tekrar deneyin.",
  
  // Update Notifications
  "update.updateAvailable": "Güncelleme Mevcut",
  "update.newVersionAvailable": "Yeni Sürüm {{version}} Mevcut",
  "update.refreshToApply": "En son özellikleri ve iyileştirmeleri uygulamak için yenileyin",
  "update.later": "Daha Sonra",
  "update.updateNow": "Şimdi Güncelle"
};